import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 59384E78-B7EF-4BDA-B537-35E537C00130
 * name format-align-middle
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-align-middle.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatAlignMiddleIcon = createSvgIcon(<><path d="M13,6L15,4L16.42,5.42L12,9.84L7.58,5.42L9,4L11,6V2H13V6M3,11H21V13H3V11M13,18V22H11V18L9,20L7.58,18.58L12,14.16L16.42,18.58L15,20L13,18Z" /></>, 'FormatAlignMiddleIcon');
export default FormatAlignMiddleIcon